<template>
  <div>
    <ContractForm
      :contract="contract"
      @clear="clearForm"
    />
    <Text
      :contract="contract"
      :company="company"
      :companyObject="companyObject"
    />
  </div>
</template>

<script>
import viewsMixin from '@/mixins/views-mixin';
import ContractForm from '@/components/ContractForm.vue';
import Text from '@/components/ConcertText.vue';

export default {
  name: 'Artist',
  components: {
    ContractForm,
    Text,
  },
  mixins: [viewsMixin],
};
</script>
